export interface JwtPayload {
  id: number;
  role: string;
  exp: number; // 토큰 만료 시각
  iat: number; // 토큰 발행 시각
  sub: string;
}

export function parsePayload(token: string): JwtPayload {
  const jwtPayload = window.atob(token.split('.')[1]);
  return JSON.parse(jwtPayload);
}
